import * as React from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';

import CustomFormControl from '../custom-form-control';
import { BaseElementInputProps } from '../field-type';
import { FormContext } from '../form';
import Switch, { SwitchProps } from '../switch';

export interface SwitchFieldProps
  extends BaseElementInputProps,
    Omit<SwitchProps, 'checked' | 'onChange'> {
  type: 'switch';
  fieldType?: 'control' | 'uncontrol';
  onAfterChange?: (checked: boolean) => void;
  noMargin?: boolean;
}

export default function SwitchField(props: SwitchFieldProps) {
  const { control } = useFormContext<any>();
  const watchValue = useWatch({ control, name: props.name });
  const {
    field: { value, ...restField },
    fieldState,
  } = useController({ name: props.name });
  const context = React.useContext(FormContext);
  const {
    fieldType = 'control',
    disabled,
    onAfterChange,
    noMargin,
    ...rest
  } = props;

  return (
    <CustomFormControl
      hideLabel
      hideRequiredStar
      error={fieldState.error?.message}
      noMargin={noMargin}
    >
      <Switch
        {...rest}
        {...restField}
        checked={fieldType === 'control' ? value : watchValue}
        onChange={(checked) => {
          restField.onChange(checked);
          onAfterChange?.(checked);
        }}
        disabled={!context.editable || disabled}
      />
    </CustomFormControl>
  );
}
